export const tableHistoriaProjektu = [
    {accessorKey: "id", header: "ID"},
    {accessorKey: "data", header: "Czas"},
    {accessorKey: "name", header: "Login użytkownika"},
    {accessorKey: "email", header: "Email użytkownika"},
    {accessorKey: "czynnosc", header: "Czynność"},
    {accessorKey: "status", header: "Status"},];
